/**
 * @generated SignedSource<<6740e2ce71873e3847440a13d6ccbba3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SchoolExamSourceActionEnum = "school_exam_source_inner_pdf_upload" | "school_exam_source_publish" | "school_exam_source_reset" | "%future added value";
export type SchoolExamSourcePublishInput = {
  id: string;
};
export type SchoolExamSourceId_schoolExamSourcePublishMutation$variables = {
  input: SchoolExamSourcePublishInput;
};
export type SchoolExamSourceId_schoolExamSourcePublishMutation$data = {
  readonly schoolExamSourcePublish: {
    readonly actions: ReadonlyArray<SchoolExamSourceActionEnum>;
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"SchoolExamSourceSchoolExamSourceHistoryPaginator_schoolExamSource" | "SchoolExamSourceStatusLabel_schoolExamSource">;
  };
};
export type SchoolExamSourceId_schoolExamSourcePublishMutation = {
  response: SchoolExamSourceId_schoolExamSourcePublishMutation$data;
  variables: SchoolExamSourceId_schoolExamSourcePublishMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actions",
  "storageKey": null
},
v4 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  },
  {
    "kind": "Literal",
    "name": "order",
    "value": {
      "created": "DESC"
    }
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v6 = [
  (v5/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "before",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "after",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SchoolExamSourceId_schoolExamSourcePublishMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SchoolExamSource",
        "kind": "LinkedField",
        "name": "schoolExamSourcePublish",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SchoolExamSourceStatusLabel_schoolExamSource"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SchoolExamSourceSchoolExamSourceHistoryPaginator_schoolExamSource"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SchoolExamSourceId_schoolExamSourcePublishMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SchoolExamSource",
        "kind": "LinkedField",
        "name": "schoolExamSourcePublish",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "SchoolExamSourceHistoryConnection",
            "kind": "LinkedField",
            "name": "histories",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SchoolExamSourceHistoryEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SchoolExamSourceHistory",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "type",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "picture",
                            "storageKey": null
                          },
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isDeleted",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "created",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "difference",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isDifference"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "scrapImages",
                                "plural": true,
                                "selections": (v6/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "SchoolExamSourcePublishDifference",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "innerPdf",
                                "plural": false,
                                "selections": (v6/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "SchoolExamSourceUploadDifference",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "histories(first:10,order:{\"created\":\"DESC\"})"
          },
          {
            "alias": null,
            "args": (v4/*: any*/),
            "filters": [
              "filters",
              "order"
            ],
            "handle": "connection",
            "key": "SchoolExamSourceSchoolExamSourceHistoryPaginator_schoolExamSource_histories",
            "kind": "LinkedHandle",
            "name": "histories"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b485d95d63e30bc87c07c72f65e58e83",
    "id": null,
    "metadata": {},
    "name": "SchoolExamSourceId_schoolExamSourcePublishMutation",
    "operationKind": "mutation",
    "text": "mutation SchoolExamSourceId_schoolExamSourcePublishMutation(\n  $input: SchoolExamSourcePublishInput!\n) {\n  schoolExamSourcePublish(input: $input) {\n    id\n    actions\n    ...SchoolExamSourceStatusLabel_schoolExamSource\n    ...SchoolExamSourceSchoolExamSourceHistoryPaginator_schoolExamSource\n  }\n}\n\nfragment DiffItem_diff on Diff {\n  before\n  after\n}\n\nfragment SchoolExamSourceHistoryDialog_SchoolExamSourceHistory on SchoolExamSourceHistory {\n  id\n  createdBy {\n    name\n    picture\n    id\n  }\n  created\n  difference {\n    __typename\n    ...SchoolExamSourcePublishDifferenceCounterLabel_difference\n    ...SchoolExamSourcePublishDifferenceItemList_difference\n    ...SchoolExamSourceUploadDifferenceCounterLabel_difference\n    ...SchoolExamSourceUploadDifferenceItemList_difference\n  }\n}\n\nfragment SchoolExamSourceHistoryTimelineItem_schoolExamSourceHistory on SchoolExamSourceHistory {\n  created\n  createdBy {\n    id\n    ...UserAvatarText_user\n  }\n  type\n}\n\nfragment SchoolExamSourcePublishDifferenceCounterLabel_difference on Difference {\n  __isDifference: __typename\n  ... on SchoolExamSourcePublishDifference {\n    scrapImages {\n      __typename\n    }\n  }\n}\n\nfragment SchoolExamSourcePublishDifferenceItemList_difference on Difference {\n  __isDifference: __typename\n  ... on SchoolExamSourcePublishDifference {\n    scrapImages {\n      ...DiffItem_diff\n    }\n  }\n}\n\nfragment SchoolExamSourceSchoolExamSourceHistoryPaginator_schoolExamSource on SchoolExamSource {\n  histories(order: {created: DESC}, first: 10) {\n    totalCount\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n    edges {\n      cursor\n      node {\n        id\n        type\n        ...SchoolExamSourceHistoryDialog_SchoolExamSourceHistory\n        ...SchoolExamSourceHistoryTimelineItem_schoolExamSourceHistory\n        __typename\n      }\n    }\n  }\n  id\n}\n\nfragment SchoolExamSourceStatusLabel_schoolExamSource on SchoolExamSource {\n  status\n}\n\nfragment SchoolExamSourceUploadDifferenceCounterLabel_difference on Difference {\n  __isDifference: __typename\n  ... on SchoolExamSourceUploadDifference {\n    innerPdf {\n      __typename\n    }\n  }\n}\n\nfragment SchoolExamSourceUploadDifferenceItemList_difference on Difference {\n  __isDifference: __typename\n  ... on SchoolExamSourceUploadDifference {\n    innerPdf {\n      ...DiffItem_diff\n    }\n  }\n}\n\nfragment UserAvatarText_user on User {\n  name\n  picture\n  isDeleted\n}\n"
  }
};
})();

(node as any).hash = "12304dc6869972d1bb5aef562b409f97";

export default node;
